import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-asngrid-popup',
  templateUrl: './asngrid-popup.component.html',
  styleUrls: ['./asngrid-popup.component.scss']
})
export class ASNGridPopupComponent {
  @Input() asnList: { fedexASN: string; vendorASN: string }[] = [];
  @Input() popupContent: string = '';
  @Output() confirm = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<string>();

  onCancel(): void {
    this.cancel.emit('cancel');
  }

  onConfirm(): void {
    this.confirm.emit('confirm');
  }
}
